// extracted by mini-css-extract-plugin
export default {"wrap":"Photos_wrap__NhQ9r","mob":"Photos_mob__+SUr1","image":"Photos_image__HyW49","grid":"Photos_grid__JFQCK"};